import React from 'react';
import { omit } from 'lodash';
import { DateTime } from 'luxon';
import {
  ChatBubbleRounded, FavoriteRounded, VisibilityRounded,
} from '@mui/icons-material';
import BarChartIcon from '@mui/icons-material/BarChart';
import { RetweetIcon } from 'elements/RetweetIcon';
import { Post } from 'lib/types';
import { NETWORKS, POST_TYPE_TEXT } from 'lib/constants';
import { MetricProps } from './types';

export const ABOVE_AVERAGE_SCORE = 1.2;
export const BELOW_AVERAGE_SCORE = 0.8;
const AVERAGE_SCORE = 1;

export const metrics: { [key: string]: MetricProps } = {
  views: {
    icon: <VisibilityRounded fontSize="small" />,
    field: 'currentCombinedViews',
    deltaField: 'deltaCombinedViews',
    renderIfNull: false,
    label: 'views',
  },
  likes: {
    icon: <FavoriteRounded fontSize="small" />,
    field: 'currentLikes',
    deltaField: 'deltaLikes',
    renderIfNull: false,
    label: 'likes',
  },
  shares: {
    icon: <RetweetIcon fontSize="small" />,
    field: 'currentShares',
    deltaField: 'deltaShares',
    renderIfNull: false,
    label: 'shares',
  },
  comments: {
    icon: <ChatBubbleRounded fontSize="small" />,
    field: 'currentComments',
    deltaField: 'deltaComments',
    renderIfNull: false,
    label: 'comments',
  },
  impressions: {
    icon: <BarChartIcon fontSize="small" />,
    field: 'currentImpressions',
    deltaField: 'deltaImpressions',
    renderIfNull: false,
    label: 'impressions',
  },
};

export const getAllowedMetrics = (network: number, isPostCard: boolean) => {
  if (isPostCard) {
    const m = omit(metrics, ['impressions']);
    return Object.values(m);
  }
  return Object.values(metrics);
};

export function getGondolaScoreIcon(score: number) {
  if (score >= AVERAGE_SCORE) {
    return '↑';
  }
  return '↓';
}

export function linkPostToExploreSearch(post: Post) {
  const network = NETWORKS[post.network].name;
  const type = POST_TYPE_TEXT[post.type].toUpperCase();
  const threeMonthsBefore = DateTime.fromISO(post.postedAt).minus({ months: 3 }).toFormat('yyyy-MM-dd');
  const threeMonthsAfter = DateTime.now() > DateTime.fromISO(post.postedAt).plus({ months: 3 }) ? DateTime.fromISO(post.postedAt).plus({ months: 3 }).toFormat('yyyy-MM-dd') : null;
  const baseUrl = `/explore?postingAccount=${post.account}&networks=${network}&fileType=${type}&minPostedAt=${threeMonthsBefore}&creditedStatus=all`;
  return threeMonthsAfter
    ? `${baseUrl}&maxPostedAt=${threeMonthsAfter}`
    : baseUrl;
}
